"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getQwDeptTree = getQwDeptTree;
exports.getQwDeptUsers = getQwDeptUsers;

var _request = _interopRequireDefault(require("@/utils/request"));

// 获取企业微信同步部门树（树形结构：deptId / name / parentId / children）
function getQwDeptTree() {
  return (0, _request.default)({
    url: 'api/syncQwDept/tree',
    method: 'get'
  });
} // 按部门ID获取该部门下的用户（不传 deptId 时返回全部用户，用于未选择部门时兜底）


function getQwDeptUsers(deptId) {
  var params = {};
  if (deptId !== undefined && deptId !== null && deptId !== '') params.deptId = deptId;
  return (0, _request.default)({
    url: 'api/syncQwDept/getAllUsers',
    method: 'get',
    params: params
  });
}

var _default = {
  getQwDeptTree: getQwDeptTree,
  getQwDeptUsers: getQwDeptUsers
};
exports.default = _default;